import React from "react";
import { bool, func, oneOf, string } from "prop-types";

const getStyles = (size, checked) => {
  const isSm = size === "sm";
  return {
    switch: {
      position: "relative",
      display: "inline-block",
      width: isSm ? 30 : 60,
      height: isSm ? 17 : 34,
      marginBottom: 0,
      marginLeft: 0,
    },
    input: {
      opacity: 0,
      width: 0,
      height: 0,
    },
    slider: {
      position: "absolute",
      cursor: "pointer",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: checked ? "#2196F3" : "#ccc",
      transition: ".4s",
      borderRadius: isSm ? 17 : 34,
      boxShadow: checked ? "0 0 1px #2196F3" : undefined,
    },
    sliderBefore: {
      position: "absolute",
      content: '""',
      height: isSm ? 13 : 26,
      width: isSm ? 13 : 26,
      left: isSm ? 2 : 4,
      bottom: isSm ? 2 : 4,
      backgroundColor: "white",
      transition: ".4s",
      borderRadius: "50%",
      transform: checked ? `translateX(${isSm ? 13 : 26}px)` : "translateX(0)",
    },
  };
};

const Toggle = (props) => {
  const styles = getStyles(props.size, props.checked);

  return (
    <label style={styles.switch} className={props.className}>
      <input
        type="checkbox"
        disabled={props.disabled}
        value={true}
        checked={props.checked}
        onChange={(e) => props.onToggle(e.target.checked)}
        style={styles.input}
      />
      <span style={styles.slider}>
        <span style={styles.sliderBefore}></span>
      </span>
    </label>
  );
};

Toggle.propTypes = {
  onToggle: func,
  checked: bool,
  size: oneOf(["sm", "lg"]),
  className: string,
  disabled: bool,
};

Toggle.defaultProps = {
  checked: false,
  size: "sm",
  className: "",
};

export { Toggle };
